const Footer = () => {
  return (
    <div>
      <section className='text-center'>
        <p>
        Join my personal newsletter
        </p>
        <div>
          <form>
            <input className="text-center" placeholder="Your Email"/>
          </form>
        </div>
        <small>Nebojša Gašparović © 2021</small>
        </section>
      </div>
      

  )
}

export default Footer;